import { styled } from '@mui/material'

export const WindowContainer = styled('div')(({ theme }) => ({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    position: 'absolute',
}))
